import React from 'react'
import { FormattedHTMLMessage } from 'react-intl'

export default () => (
  <div className='Container'>
    <div className='NotFound'>
      <div className='NotFound__body'>
        <h1 className='NotFound__head'>404</h1>
        <p className='NotFound__caption'>
          <FormattedHTMLMessage id='404.message' />
        </p>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/containers/404.jsx